<main
  class="relative flex min-h-svh w-full items-center justify-center bg-[url('/assets/login-assets/forgot-password-bg.jpg')] bg-cover bg-center px-4 py-20"
>
  <button
    type="button"
    class="absolute left-8 top-7 flex items-center gap-2 text-sm font-medium text-white"
    (click)="backToLogin()"
  >
    <svg-icon
      src="assets/svgs/arrow-left-alt.svg"
      [svgStyle]="{ 'width.px': 16, 'height.px': 16 }"
    ></svg-icon>
    Back to Login
  </button>

  <app-forgot-password-ui
    class="w-full max-w-[460px]"
    [standalonePage]="true"
  ></app-forgot-password-ui>
</main>
